import { IPartsRepository } from "../IPartsRepository";
import response from '../../database/parts.json';
import { Part } from "../../entities/Part";

export class JsonPartsRepository implements IPartsRepository
{
    async fetchAll(): Promise<Part[]>
    {
        const parts = response.parts;
        const allParts = parts.map((part) => {
            return new Part(part.title, part.link, part.sections);
        });
        console.log(true);
        return allParts;
    }

    async findById(id: number): Promise<Part|null>
    {
        if (id === 0 || id < 0 || id >= 5) {
            return null;
        }

        const foundPart = response.parts[id-1];

        const part = new Part(foundPart.title, foundPart.link, foundPart.sections);

        return part;
    }
}